<script lang="ts">
  import SearchNormal from '$icons/SearchNormalIcon.svelte';
  import InputWithOptionIconLeft from '$lib/components/common/inputs/textInputs/TextInputWithOptionsIconLeft.svelte';
  import { clickOutside } from '$src/utils/clickOutside.util';
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition'; 

  export let label;
  export let caption;
  export let placeholder = '';
  export let danger: boolean = false;
  export let dangerMessage: string = '';

  export let multiple = false;
  export let value = '';
  export let required: boolean = false;

  export let options: string[] = [];
  export let selectedValues: string[] = [];

  export let dropdownOpen = false;
  export let inputFocused = false;
  $: dropdownClicked = false;

  export let notReadOnly = false;

  export let selectedValuesBuffer: {
    icon: string;
    title: string;
    description: string;
    value: string;
  }[] = [];

  const dispatch = createEventDispatcher();

  $: {
    dispatch('change', { value, selectedValues });
  }

  $: {
    dropdownOpen = inputFocused || dropdownClicked;
  }
</script>

<button
  class="relative"
  use:clickOutside
  on:click_outside={() => {
    dropdownOpen = false;
  }}
  on:click={() => {
    if (inputFocused) return;
    inputFocused = true;
  }}
  on:keydown
>
  <InputWithOptionIconLeft
    bind:label
    bind:caption
    bind:searchValue={value}
    bind:placeholder
    bind:danger
    bind:dangerMessage
    bind:selectedValues={selectedValuesBuffer}
    {required}
    readonly={!notReadOnly}
    cursorPointer={!notReadOnly}
    on:submit
    on:click={() => {
      inputFocused = true;
      dropdownOpen = true;
    }}
    on:click_outside={() => {
      // inputFocused = false;
      // dropdownOpen = false;
    }}
  >
    <slot name="icon">
      <button
        class="cursor-pointer ease-in-out duration-200 transform select-none"
        on:click|stopPropagation={() => {
          dropdownOpen = !dropdownOpen;
          inputFocused = dropdownOpen;
        }}
        on:keydown
      >
        <SearchNormal />
      </button>
    </slot>
  </InputWithOptionIconLeft>
  {#if dropdownOpen}
    <button
      class="dropdown"
      class:-mt-4={!caption}
      class:mt-1={caption}
      on:keydown
      on:click={() => {
        dropdownClicked = true;
      }}
      use:clickOutside
      on:click_outside={() => {
        dropdownClicked = false;
      }}
    >
      <slot>
        {#each options as option}
          <button
            class="flex flex-row items-center border-y hover:border-[#F2F4F7] border-white px-4 py-3 cursor-pointer text-garden-grey-700"
            on:keydown
            on:click|stopPropagation={() => {
              dropdownOpen = false;
              inputFocused = false;
              if (selectedValues.includes(option)) return;
              if (multiple) {
                selectedValues = [...selectedValues, option];
                selectedValuesBuffer = [
                  ...selectedValuesBuffer,
                  {
                    icon: '',
                    title: option,
                    description: '',
                    value: option
                  }
                ];
              } else {
                value = option;
              }
            }}
            transition:slide|global={{ duration: 100 }}
          >
            {option}
          </button>
        {/each}
      </slot>
    </button>
  {/if}
</button>

<style type="postcss">
  .dropdown {
    @apply overflow-y-auto absolute z-50 bg-white w-full max-h-[200px] rounded-10 border border-garden-grey-200 text-sm font-medium flex flex-col;
    box-shadow:
      0px 12px 16px -4px rgba(16, 24, 40, 0.08),
      0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }
</style>
